import React from 'react';

/*
const StyledTableCell = styled(TableCell)({
  borderBottom: 'none',
});
*/

// TODO
const NoBorderTableCell = ({ children, ...otherProps }: any) => (
  <span>TODO: NoBorderTableCell</span>
  //<StyledTableCell {...otherProps}>{children}</StyledTableCell>
);

export default NoBorderTableCell;
